import { Icon } from "@blueprintjs/core";
import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";

export function TemplateBuilderMultiSelectPreview({ question, answer, onChange, deleteComponent, addAnotherComponent }) {
    const value = useMemo(() => {
        if (!answer?.answers) {
            return []
        }

        if (Array.isArray(answer?.answers)) {
            return answer.answers;
        }

        return answer.answers.split(',');
    }, [answer]);

    //Load default value
    useEffect(() => {
        if (answer?.answers) {
            return;
        }

        const defaultValue = question
            ?.options
            .filter(o => o.selectedByDefault)
            .map(o => o.id);

        defaultValue?.length && handleChange(defaultValue);
    }, [value, question?.options]);

    const handleChange = (newValue = []) => {
        const newAnswer = {
            ...answer,
            $answerType: "MultiSelect",
            questionId: question.id,
            answers: newValue,
            isAnswered: newValue && newValue.length > 0
        };

        onChange(newAnswer);
    };

    const toggleOption = (optionId) => {
        const isSelected = !!value.find(o => o === optionId);

        const newValue = isSelected
            ? value.filter(o => o !== optionId)
            : [...value, optionId];

        handleChange(newValue);
    };

    return <div className="check-preview-form-field">
        <div className="check-preview-input-container">
            <div className="multi-select">
                {question?.options.map(option => (
                    <button
                        key={option.id}
                        className={`bp6-button bp6-large btn-form multi-select-option ${value.includes(option.id) ? 'active' : ''}`}
                        onClick={() => toggleOption(option.id)}
                    >
                        <span className="bp6-button-text">{option.name}</span>
                        <Icon icon="tick" />
                    </button>
                ))}
            </div>
            {deleteComponent}
        </div>
        {addAnotherComponent}
    </div>
}

TemplateBuilderMultiSelectPreview.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    addAnotherComponent: PropTypes.node.isRequired,
    deleteComponent: PropTypes.node.isRequired
};